import { ACTION_TYPES } from 'app/modules/account/service/store/actions';
import { emptyRedirectLink } from 'app/modules/claim/service';
import { getDocCMS } from 'app/modules/cms/service/cmsService';
import { getContractCustomerSelector, getContractStatusCms, getModalInformationButton } from 'app/modules/cms/service/store/selectors';
import {
  getActiveSubscriptionByClient, getAllSubscriptionByClient, recoverAndActiveSubscriptionsClients, resetContract, resetUserInfo, setPage
} from 'app/modules/contract/service';
import { getSubscriptionsList } from 'app/modules/contract/service/store/selectors';
import { ContractAreaList } from 'app/modules/contract/ui/components/desktop/contract-area-list/contract-area-list';
import { returnComponenet } from 'app/modules/contract/ui/tools/constants';
import { getSellingPoints } from 'app/modules/global/service/globalService';
import { RulesKeys } from 'app/modules/rules/domain/rules.keys';
import { RulesContext } from 'app/modules/rules/domain/RulesContext';
import { View } from 'app/modules/rules/domain/View';
import { getDataView } from 'app/modules/rules/service/rulesService';
import { getDataViewRules } from 'app/modules/rules/service/store/selectors';
import ConfComponent from 'app/shared/components/common/conf-component';
import ModalWithAction from 'app/shared/components/common/modal/modal-with-Action';
import PaginationComp from 'app/shared/components/desktop/pagination/pagintationComp';
import { IRootState } from 'app/shared/reducers';
import { verifName, verifNumber } from 'app/shared/util/verif-search.util';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './style.scss';

import { ButtonLounge } from 'app/shared/components/common/button/button-louge';
import AvatarWithBadge from 'app/shared/components/mobile/avatar-with-badge/avatar-with-badge';
import ContractPageSkeleton from 'app/shared/components/skeleton/desktop/s-contract-page';
import { useHistory } from 'react-router-dom';
import { replaceDocumentsCms } from 'app/shared/util/methode-util';

export interface IContract {
  data: any;
}

export const ContractPage = () => {
  const device: any = useSelector<IRootState>(state => state.global?.deviceType || '');

  const rulesContext: RulesContext = {
    key: RulesKeys.GET_VIEW_DATA_CONFIGURATION,
    entryDataRules: { view: View.CONTRACTS, deviceType: device },
  };
  const dispatchor = useDispatch();
  const history = useHistory();
  const modalInformation: any = useSelector(getModalInformationButton)

  const appStyle: any = useSelector<IRootState>(state => state.cms?.documents['app_global_type']);
  const cmsContractItem: any = useSelector<IRootState>(state => state.cms?.documents['contract_items_table'] || []);
  const cmsContractListe: any = useSelector<IRootState>(state => state.cms?.documents['contract_liste'] || []);
  const contractStatusCms: any = useSelector(getContractStatusCms);
  const subscriptionList: any = useSelector(getSubscriptionsList);
  const constractLoading: boolean = useSelector<IRootState>(state => state.contract?.loading) as boolean;
  const constractCms: boolean = useSelector<IRootState>(state => state.cms.loading) as boolean;
  const constractListPage: number = useSelector<IRootState>(state => state.contract?.page || 1) as number;
  const sellingPoints: any = useSelector<IRootState>(state => state.global.sellingPoints);
  const defaultSellingPointCode: any = useSelector<IRootState>(state => state.sellingPoint?.connectedSellingPoint?.code || '');
  const defaultSellingPointName: any = useSelector<IRootState>(state => state.sellingPoint?.connectedSellingPoint?.name || '');
  const viewDataitems = useSelector(getDataViewRules(View.CONTRACTS));
  const redirectLink: any = useSelector<IRootState>(state => state.claim.redirectLink);
  const userInfoUpdated: any = useSelector<IRootState>(state => state.contract.updated);
  const [inputSearch, setInputSearch] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [sellingPointSearch, setSellingPointSearch] = useState(defaultSellingPointCode);
  const [sellingPointValue, setSellingPointValue] = useState(defaultSellingPointName);
  const [emptySearch, setEmptySearch] = useState(returnComponenet['FIRST']);
  const [openModal, setOpenModal] = useState(false);
  const [openModalLength, setOpenModalLength] = useState(false);
  const [subscriptionListTodisplay, setSubscriptionListTodisplay] = useState([]);
  const avatar: any = useSelector<IRootState>(state => state.global.avatar);

  const cmsContractAndClaimtStatus: any = useSelector<IRootState>(
    state => state.cms?.documents['desktop_contract_and_claim_status_v2'] || []
  );
  const contractCustomerCms: any = useSelector(getContractCustomerSelector);
  useEffect(() => {
    dispatchor(getDataView(rulesContext));
    setSubscriptionListTodisplay(subscriptionList);
  }, []);

  useEffect(() => {
   
    setSubscriptionListTodisplay(subscriptionList);
  }, [subscriptionList]);
  useEffect(() => {
    if (defaultSellingPointCode && !sellingPointSearch) {
      setSellingPointSearch(defaultSellingPointCode);
      setSellingPointValue(defaultSellingPointName);
    }
  }, [defaultSellingPointCode]);

  useEffect(() => {
    if (redirectLink && redirectLink === 'error') {
      setOpenModal(true);
    } else {
      if (redirectLink != null) { (window.location.href = redirectLink) };
    }

    dispatchor(emptyRedirectLink());
  }, [redirectLink]);

  useEffect(() => {
    if (userInfoUpdated === true) {
      dispatchor(resetUserInfo());
    }
  }, []);

  useEffect(() => {
    if (viewDataitems?.dataRecoveryService?.find(service => service === 'GetActiveSubscriptionList'))
      dispatchor(getActiveSubscriptionByClient());
    if (viewDataitems?.dataRecoveryService?.find(service => service === 'RecoverAndActiveSubscriptionsClients'))
      dispatchor(recoverAndActiveSubscriptionsClients());

    if (viewDataitems?.dataRecoveryService?.find(service => service === 'DesktopContractPdv')) {
      dispatchor(getDocCMS('desktop_contract_pdv_v2'));
    }
    if (viewDataitems?.dataRecoveryService?.find(service => service === 'DesktopContractCustomer')) {
      dispatchor(getDocCMS('desktop_contract_customer_v2'));
    }
  }, [viewDataitems]);


  const onInputChange = input => {
    if (input === '') setSellingPointSearch('');
    setSellingPointValue(input);
    if (input?.length && input?.length > 2) {
      dispatchor(getSellingPoints(input));
    }
  };
  const searchHandle = (search: any, sellingPointCode: any) => {
    if (sellingPointCode === '' || sellingPointCode === undefined) {
      setShowModal(true);
    } else {
      if (search === '') {
        setEmptySearch(returnComponenet['EMPTY']);
      } else {
        setEmptySearch(returnComponenet['ARRAY-RESULT']);
        if (verifNumber(search)) dispatchor(getAllSubscriptionByClient({ subscriptionNumber: search?.padStart(12, 0) }));
        // Pas de selling point quand recherche adhesion
        else {
         if (verifName(search)){
          dispatchor(getAllSubscriptionByClient({ lastName: search, ...(sellingPointCode ? { sellingPointCode } : {}) }));
         }else{
          setEmptySearch(returnComponenet['EMPTY'])
          setSubscriptionListTodisplay([])
         }
        }
      }
    }
  };

  const setListPage = (page: number) => {
    dispatchor(setPage(page));
  };

  const resetContractHandler = () => {
    dispatchor(resetContract());
    setSellingPointSearch(defaultSellingPointCode);
    setSellingPointValue(defaultSellingPointName);
    setEmptySearch(returnComponenet['FIRST'])

  };

  const resetContracts = () => {
    resetContractHandler();
    setInputSearch('');
  };

  const handleRedirect = () => {
    dispatchor({ type: ACTION_TYPES.RESET_STATE });
    history.push(`/account-engine`);
  };

  function replaceDocumentsCmsPluralCostumer(): string | number | boolean | {} | React.ReactElement<any, string | React.JSXElementConstructor<any>> | React.ReactNodeArray | React.ReactPortal {
    throw new Error('Function not implemented.');
  }

  return (
    <>
      {(!(constractLoading || constractCms) &&
        (viewDataitems?.componentDataList || []).find(x => x.componentDataKey === 'DESKTOP_SEARCH_SUBSCRIPTION_SPACE') &&
        subscriptionList?.length > 0) &&
        <>
          <div className='search-div'>
            <p>{contractCustomerCms?.search_subscription?.searchLink} <span className='search-link' onClick={handleRedirect}>{contractCustomerCms?.search_subscription?.searchActionLink}</span></p>
          </div>
          <div className="mb-4"></div>
        </>
      }


      {/* <PageTitel text={contractCustomerCms?.page_title} /> */}
      {(viewDataitems?.componentDataList || []).find(x => x.componentDataKey === 'SEARCH_SPACE') && (
        <ConfComponent
          code="SEARCH_SPACE"
          listCode={viewDataitems?.componentDataList}
          props={{
            sellingPointValue,
            sellingPointSearch,
            setSellingPointSearch,
            sellingPoints,
            inputSearch,
            setInputSearch,
            searchHandle,
            onInputChange,
            defaultSellingPoint: defaultSellingPointName,
            contractCustomerCms,
            resetContracts,
          }}
        />
      )}
     {(viewDataitems?.componentDataList || []).find(x => x.componentDataKey === 'SEARCH_SPACE')?.params?.SHOW_SEARCH_RESULT===true &&
      <div className="resultat_style d-flex justify-content-between">
         { contractCustomerCms?.search_result && replaceDocumentsCms(subscriptionListTodisplay?.length+" "+contractCustomerCms?.search_result,"${s}",subscriptionListTodisplay?.length <= 1 ? '' : 's')} 
        { contractCustomerCms?.search_label && replaceDocumentsCmsPluralCostumer() }
      </div>}
      {constractLoading || constractCms ? (
        <ContractPageSkeleton />
      ) : (
        ((viewDataitems?.componentDataList || []).find(x => x.componentDataKey === 'DESKTOP_SEARCH_SUBSCRIPTION_SPACE')
          && subscriptionList?.length === 0) ?
          <>
            <div className='no-contracts-content text-center'>
              <AvatarWithBadge
                hideButton
                avatar={avatar}
                title=
                {[contractCustomerCms?.search_subscription?.avatarText]}
              />
              <br />
              <ButtonLounge title={contractCustomerCms?.search_subscription?.searchButton} action={handleRedirect} style={'HomeMobile1 large2 btnRadius'} />
            </div>
          </>
          :
          <>
            <ContractAreaList
              setInputSearch={setInputSearch}
              cmsContractItem={cmsContractItem}
              cmsContractListe={cmsContractListe.data}
              contractStatusCms={contractStatusCms}
              listPage={constractListPage}
              data={subscriptionListTodisplay}
              emptySearch={emptySearch}
              resetContractHandler={resetContractHandler}
              dataConf={viewDataitems}
              contractCustomerCms={contractCustomerCms}
              cmsContractAndClaimtStatus={cmsContractAndClaimtStatus}
            />
            {(viewDataitems?.componentDataList || []).find(x => x.componentDataKey === 'PAGINATION_SPACE') && (
              <PaginationComp data={subscriptionList} listPage={constractListPage} emptySearch={emptySearch} setListPage={setListPage} />
            )}
          </>
      )}

      <ModalWithAction
        icon={modalInformation?.erreur_Icon?.url}
        showModal={openModal}
        setShowModel={setOpenModal}
        textBody={contractCustomerCms?.check_declar_claim_message}
        action={() => {
          setOpenModal(false);
        }}
        btnActionLabel={modalInformation?.CLOSE_button}

      />

      <ModalWithAction
        icon={modalInformation?.erreur_Icon?.url}
        showModal={openModalLength}
        setShowModel={setOpenModalLength}
        textBody={contractCustomerCms?.check_length_name_search}
        action={() => {
          setOpenModalLength(false);
        }}
        btnActionLabel={modalInformation?.CLOSE_button}

      />

      <ModalWithAction
        icon={modalInformation?.erreur_Icon?.url}
        showModal={showModal}
        setShowModel={setShowModal}
        textBody={contractCustomerCms?.check_store_message}
        action={() => {
          setShowModal(false);
        }}
        btnActionLabel={modalInformation?.CLOSE_button}

      />
    </>
  );
};
